import { GLOBAL_BLOCKLIST_KEYS, WORKFLOW_ALLOWLIST } from './constants';
import { Workflow } from './types';

const isAllowedValue = (value: unknown): boolean => {
  return (
    value === null ||
    typeof value === 'string' ||
    typeof value === 'number' ||
    typeof value === 'boolean'
  );
};

export const sanitizeWorkflowAttributes = (
  workflow: Workflow,
  attributes: Record<string, unknown> = {}
): Record<string, unknown> => {
  const allowlist = new Set(WORKFLOW_ALLOWLIST[workflow] || []);
  const blocklist = new Set(GLOBAL_BLOCKLIST_KEYS);

  return Object.entries(attributes).reduce<Record<string, unknown>>((acc, [key, value]) => {
    const normalizedKey = key.toLowerCase();
    if (!allowlist.has(key) || blocklist.has(normalizedKey)) {
      return acc;
    }

    if (isAllowedValue(value)) {
      acc[key] = value;
    }
    return acc;
  }, {});
};
